// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

export const getClients = wrapWithNetworkError(function(token) {
  const fetchUrl = getEndpointUrl('/merchantGroup');
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json());
});



// WEBPACK FOOTER //
// ./src/containers/client/clientsApi.js